export default function Testimonial() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1200px] mx-auto">
        <div className="relative flex flex-col lg:flex-row bg-foreground-900 rounded-2xl overflow-visible">
          <div className="lg:w-[38%] relative -mt-10 lg:-mt-12 lg:-ml-10 mb-6 lg:mb-0 z-10">
            <div className="w-full h-[280px] md:h-[380px] lg:h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20executive%20portrait%20of%20a%20confident%20business%20leader%20in%20a%20modern%20minimalist%20setting%2C%20wearing%20a%20tailored%20navy%20suit%2C%20neutral%20gray%20studio%20backdrop%2C%20soft%20professional%20lighting%2C%20clean%20corporate%20aesthetic%2C%20natural%20expression%2C%20editorial%20quality%2C%20shallow%20depth%20of%20field&width=600&height=800&seq=testimonial-portrait-01&orientation=portrait"
                alt="Client testimonial portrait"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[62%] flex flex-col justify-center px-6 md:px-10 py-8 md:py-12 lg:py-16">
            <div className="text-accent-500 text-6xl md:text-7xl font-heading leading-none mb-4 md:mb-6 opacity-80">
              &ldquo;
            </div>
            <blockquote className="text-white text-lg md:text-xl lg:text-2xl leading-relaxed font-heading italic mb-8 md:mb-10">
              We ship irreplaceable vintage timepieces to collectors across three continents. INTL Couriers is the only service we trust — their chain-of-custody protocol, real-time tracking, and full-value insurance give us and our clients absolute peace of mind.
            </blockquote>
            <div className="mb-8">
              <p className="text-white font-semibold text-sm md:text-base">Elena Voss</p>
              <p className="text-white/50 text-xs md:text-sm">Director of Logistics, Voss Horology Group, Geneva</p>
            </div>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-400 text-foreground-950 font-semibold text-sm hover:bg-accent-300 transition-colors duration-300 whitespace-nowrap cursor-pointer self-start"
            >
              Read More Client Stories
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6 mt-6 md:mt-8 px-2">
          <p className="text-foreground-500 text-xs font-medium tracking-wide uppercase">Trusted by</p>
          <div className="flex flex-wrap items-center gap-5 md:gap-8">
            {['Sotheby\'s', 'Christie\'s', 'De Beers', 'Patek Philippe', 'Rolex CPO'].map((brand) => (
              <span key={brand} className="text-foreground-300 text-sm font-semibold tracking-wide">
                {brand}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}